type MimeTypes = {
	[key: string]: { category: string; extensions: string[] };
};

export const defaultMimeType = "genericfile";

export const mimeTypes: MimeTypes = {
	accdb: {
		category: defaultMimeType,
		extensions: ["accdb", "mdb"],
	},
	archive: {
		category: "Archive",
		extensions: [
			"7z",
			"ace",
			"arc",
			"arj",
			"dmg",
			"gz",
			"iso",
			"lzh",
			"pkg",
			"rar",
			"sit",
			"tgz",
			"tar",
			"z",
		],
	},
	audio: {
		category: "Audio",
		extensions: [
			"aif",
			"aiff",
			"aac",
			"alac",
			"amr",
			"ape",
			"au",
			"awb",
			"dct",
			"dss",
			"dvf",
			"flac",
			"gsm",
			"m4a",
			"m4p",
			"mid",
			"mmf",
			"mp3",
			"oga",
			"ra",
			"rm",
			"wav",
			"wma",
			"wv",
		],
	},
	calendar: {
		category: "Calendar",
		extensions: ["ical", "icalendar", "ics", "ifb", "vcs"],
	},
	code: {
		category: "Code",
		extensions: [
			"abap",
			"ada",
			"adp",
			"ahk",
			"as",
			"as3",
			"asc",
			"ascx",
			"asm",
			"asp",
			"awk",
			"bash",
			"bash_login",
			"bash_logout",
			"bash_profile",
			"bashrc",
			"bat",
			"bib",
			"bsh",
			"build",
			"builder",
			"c",
			"cbl",
			"c++",
			"capfile",
			"cc",
			"cfc",
			"cfm",
			"cfml",
			"cl",
			"clj",
			"cls",
			"cmake",
			"cmd",
			"coffee",
			"config",
			"cpp",
			"cpt",
			"cpy",
			"cs",
			"cshtml",
			"cson",
			"csproj",
			"css",
			"ctp",
			"cxx",
			"d",
			"ddl",
			"di",
			"disco",
			"dml",
			"dtd",
			"dtml",
			"el",
			"emakefile",
			"erb",
			"erl",
			"f",
			"f90",
			"f95",
			"fs",
			"fsi",
			"fsscript",
			"fsx",
			"gemfile",
			"gemspec",
			"gitconfig",
			"go",
			"groovy",
			"gvy",
			"h",
			"h++",
			"haml",
			"handlebars",
			"hbs",
			"hcp",
			"hh",
			"hpp",
			"hrl",
			"hs",
			"htc",
			"hxx",
			"idl",
			"iim",
			"inc",
			"inf",
			"ini",
			"inl",
			"ipp",
			"irbrc",
			"jade",
			"jav",
			"java",
			"js",
			"json",
			"jsp",
			"jsproj",
			"jsx",
			"l",
			"less",
			"lhs",
			"lisp",
			"log",
			"lst",
			"ltx",
			"lua",
			"m",
			"mak",
			"make",
			"manifest",
			"master",
			"md",
			"markdn",
			"markdown",
			"mdown",
			"mkdn",
			"ml",
			"mli",
			"mll",
			"mly",
			"mm",
			"mud",
			"nfo",
			"opml",
			"osascript",
			"p",
			"pas",
			"patch",
			"php",
			"php2",
			"php3",
			"php4",
			"php5",
			"phtml",
			"pl",
			"pm",
			"pod",
			"pp",
			"profile",
			"ps1",
			"ps1xml",
			"psd1",
			"psm1",
			"pss",
			"pt",
			"py",
			"pyw",
			"r",
			"rake",
			"rb",
			"rbx",
			"rc",
			"rdf",
			"re",
			"reg",
			"rest",
			"resw",
			"resx",
			"rhtml",
			"rjs",
			"rprofile",
			"rpy",
			"rss",
			"rst",
			"ruby",
			"rxml",
			"s",
			"sass",
			"scala",
			"scm",
			"sconscript",
			"sconstruct",
			"script",
			"scss",
			"sgml",
			"sh",
			"shtml",
			"sml",
			"svn-base",
			"swift",
			"sql",
			"sty",
			"tcl",
			"tex",
			"textile",
			"tld",
			"tli",
			"tmpl",
			"tpl",
			"vb",
			"vi",
			"vim",
			"vmg",
			"webpart",
			"wsp",
			"wsdl",
			"xhtml",
			"xoml",
			"xsd",
			"xslt",
			"yaml",
			"yaws",
			"yml",
			"zsh",
			"tsx",
		],
	},
	contact: {
		category: defaultMimeType,
		extensions: ["vcf"],
	},
	csv: {
		category: "Document",
		extensions: ["csv"],
	},
	docx: {
		category: "Document",
		extensions: ["doc", "docm", "docx", "docb"],
	},
	dotx: {
		category: "Document",
		extensions: ["dot", "dotm", "dotx"],
	},
	email: {
		category: "Email",
		extensions: ["eml", "msg", "ost", "pst"],
	},
	exe: {
		category: "Application",
		extensions: [
			"application",
			"appref-ms",
			"apk",
			"app",
			"appx",
			"exe",
			"ipa",
			"msi",
			"xap",
		],
	},
	font: {
		category: "Font",
		extensions: ["ttf", "otf", "woff"],
	},
	fluid: {
		category: defaultMimeType,
		extensions: ["b", "fluid"],
	},
	html: {
		category: "HTML",
		extensions: ["htm", "html", "mht"],
	},
	link: {
		category: "Link",
		extensions: ["lnk", "link", "url", "website", "webloc"],
	},
	officescript: {
		category: defaultMimeType,
		extensions: ["osts"],
	},
	splist: {
		category: defaultMimeType,
		extensions: ["listitem"],
	},
	model: {
		category: "Model",
		extensions: [
			"3ds",
			"3mf",
			"blend",
			"cool",
			"dae",
			"df",
			"dwfx",
			"dwg",
			"dxf",
			"fbx",
			"glb",
			"gltf",
			"holo",
			"layer",
			"layout",
			"max",
			"mcworld",
			"mtl",
			"obj",
			"off",
			"ply",
			"skp",
			"stp",
			"stl",
			"t",
			"thl",
			"x",
		],
	},
	mpp: {
		category: defaultMimeType,
		extensions: ["mpp"],
	},
	mpt: {
		category: defaultMimeType,
		extensions: ["mpt"],
	},
	one: {
		category: "Document",
		extensions: ["note", "one"],
	},
	onetoc: {
		category: "Document",
		extensions: ["ms-one-stub", "onetoc", "onetoc2", "onepkg"],
	},
	pdf: {
		category: "Document",
		extensions: ["pdf"],
	},
	photo: {
		category: "Image",
		extensions: [
			"arw",
			"bmp",
			"cr2",
			"crw",
			"dic",
			"dicm",
			"dcm",
			"dcm30",
			"dcr",
			"dds",
			"dib",
			"dng",
			"erf",
			"gif",
			"heic",
			"heif",
			"ico",
			"jfi",
			"jfif",
			"jif",
			"jpe",
			"jpeg",
			"jpg",
			"kdc",
			"mrw",
			"nef",
			"orf",
			"pct",
			"pict",
			"png",
			"pns",
			"psb",
			"psd",
			"raw",
			"tga",
			"tif",
			"tiff",
			"wdp",
		],
	},
	potx: {
		category: defaultMimeType,
		extensions: ["pot", "potm", "potx"],
	},
	powerbi: {
		category: defaultMimeType,
		extensions: ["pbids", "pbix"],
	},
	ppsx: {
		category: defaultMimeType,
		extensions: ["pps", "ppsm", "ppsx"],
	},
	pptx: {
		category: defaultMimeType,
		extensions: ["ppt", "pptm", "pptx", "sldx", "sldm"],
	},
	presentation: {
		category: "Presentation",
		extensions: ["odp", "gslides", "key"],
	},
	pub: {
		category: defaultMimeType,
		extensions: ["pub"],
	},
	spo: {
		category: defaultMimeType,
		extensions: ["aspx", "classifier"],
	},
	spreadsheet: {
		category: "Spreadsheet",
		extensions: ["odc", "ods", "gsheet", "numbers", "tsv"],
	},
	rtf: {
		category: "Rtf",
		extensions: ["epub", "gdoc", "odt", "rtf", "wri", "pages"],
	},
	sysfile: {
		category: "System",
		extensions: [
			"bak",
			"bin",
			"cab",
			"cache",
			"cat",
			"cer",
			"class",
			"dat",
			"db",
			"dbg",
			"dl_",
			"dll",
			"ithmb",
			"jar",
			"kb",
			"ldt",
			"lrprev",
			"pkpass",
			"ppa",
			"ppam",
			"pdb",
			"rom",
			"thm",
			"thmx",
			"vsl",
			"xla",
			"xlam",
			"xlb",
			"xll",
		],
	},
	txt: {
		category: "Text",
		extensions: [
			"dif",
			"diff",
			"readme",
			"out",
			"plist",
			"properties",
			"text",
			"txt",
		],
	},
	vector: {
		category: "Image",
		extensions: [
			"ai",
			"ait",
			"cvs",
			"dgn",
			"gdraw",
			"pd",
			"emf",
			"eps",
			"fig",
			"ind",
			"indd",
			"indl",
			"indt",
			"indb",
			"ps",
			"svg",
			"svgz",
			"wmf",
			"oxps",
			"xps",
			"xd",
			"sketch",
		],
	},
	video: {
		category: "Video",
		extensions: [
			"3g2",
			"3gp",
			"3gp2",
			"3gpp",
			"asf",
			"avi",
			"dvr-ms",
			"flv",
			"m1v",
			"m4v",
			"mkv",
			"mod",
			"mov",
			"mm4p",
			"mp2",
			"mp2v",
			"mp4",
			"mp4v",
			"mpa",
			"mpe",
			"mpeg",
			"mpg",
			"mpv",
			"mpv2",
			"mts",
			"ogg",
			"qt",
			"swf",
			"ts",
			"vob",
			"webm",
			"wlmp",
			"wm",
			"wmv",
			"wmx",
			"mxf",
		],
	},
	vsdx: {
		category: defaultMimeType,
		extensions: ["vdx", "vsd", "vsdm", "vsdx", "vsw", "vdw"],
	},
	vssx: {
		category: defaultMimeType,
		extensions: ["vss", "vssm", "vssx"],
	},
	vstx: {
		category: defaultMimeType,
		extensions: ["vst", "vstm", "vstx", "vsx"],
	},
	whiteboard: {
		category: defaultMimeType,
		extensions: ["whiteboard"],
	},
	xlsx: {
		category: defaultMimeType,
		extensions: ["xlc", "xls", "xlsb", "xlsm", "xlsx", "xlw"],
	},
	xltx: {
		category: defaultMimeType,
		extensions: ["xlt", "xltm", "xltx"],
	},
	xml: {
		category: "XML",
		extensions: ["xaml", "xml", "xsl"],
	},
	xsn: {
		category: defaultMimeType,
		extensions: ["xsn"],
	},
	zip: {
		category: "Archive",
		extensions: ["zip"],
	},
};

export const mimeTypeKeys = Object.keys(mimeTypes);
